import React, { useState, useEffect } from "react";

import { CiSaveUp1 } from "react-icons/ci";

export default function ScrollTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const clickTopScroll = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <>
      {isVisible &&
        <div onClick={clickTopScroll} className="scroll-up">
          <CiSaveUp1 />
        </div>}
    </>
  );
}
